import gql from 'graphql-tag';

const mutation = gql`
  mutation resubscribe($email: String!, $tmc: String!, $altcha: String) {
    resubscribe(input: { email: $email, tmc: $tmc, altcha: $altcha }) {
      result
      success
      message
    }
  }
`;

export default function resubscribe({ apollo, email, tmc, altcha = null }) {
  return apollo.mutate({
    mutation,
    variables: {
      email,
      tmc,
      altcha
    }
  });
}
